import { useCallback, useState } from "react"
import i18next from "i18next"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { ServicePoints } from "../../Objects/ServicePoint/ServicePoints"

export const useCreateServicePoint = () => {
  const [servicePointName, setServicePointName] = useState("")
  
  const [description, setDescription] = useState("")
  
  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)
  
  const [servicePoint, setServicePoint] = useState<ServicePoints | null>(null)

  const handleServicePointNameChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => setServicePointName(event.target.value),
    [],
  )

  const handleDescriptionChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => setDescription(event.target.value),
    [],
  )

  const handleStatusChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => setStatus(event.target.selectedIndex as EEnableStatusType),
    [],
  )

  const handleInitialValue = useCallback((initialServicePoint: ServicePoints | null | undefined) => {
    setServicePoint(initialServicePoint ?? null)
    setServicePointName(initialServicePoint?.name ?? "")
    setDescription(initialServicePoint?.description ?? "")
    setStatus(initialServicePoint?.status ?? EEnableStatusType.Active)
  }, [])

  const handleSubmitForm = useCallback((): ServicePoints | { errors: ValidationError[] } => {
    const errors: ValidationError[] = []
    const name = servicePointName.trim()

    if (name.length === 0 || name.length > 80) {
      errors.push({
        field: i18next.t("servicePoints:field_name"),
        message: i18next.t("servicePoints:error_invalid_name"),
      })
    }

    if (description.trim().length > 200) {
      errors.push({
        field: i18next.t("servicePoints:field_description"),
        message: i18next.t("servicePoints:error_invalid_description"),
      })
    }

    if (errors.length > 0) {
      return { errors }
    }

    return new ServicePoints({
      id: servicePoint?.id ?? -1,
      name,
      description: description.trim(),
      status,
    })
  }, [description, servicePoint, servicePointName, status])

  return {
    Name: servicePointName,
    Description: description,
    Status: status,
    handleServicePointNameChange,
    handleDescriptionChange,
    handleStatusChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
